import dashboardReducer from './reducers';

export { default as dashboardActions } from './actions';
export { default as dashboardSelectors } from './selectors';

export default dashboardReducer;
